import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Council, CouncilControllerService } from '../../../../core/generated';

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MaterialModule } from '../../../../shared/material/material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';

const CouncilGroupEnum: { [key: string]: string } = {
  CRM: 'Conselho Regional De Medicina',
  COREN: 'Conselho Regional De Enfermagem',
  CRO: 'Conselho Regional De Odontologia',
  CRF: 'Conselho Regional De Farmácia',
  CREFITO: 'Conselho Regional De Fisioterapia',
  CRP: 'Conselho Regional De Psicologia',
  CRBM: 'Conselho Regional De Biomedicina',
  CRN: 'Conselho Regional De Nutrição',
  CREF: 'Conselho Regional De Educação Física',
  CREFONO: 'Conselho Regional De Fonoaudiologia',
  CRESS: 'Conselho Regional De Serviço Social',
  CRMV: 'Conselho Regional De Medicina Veterinária',
  CRTR: 'Conselho Regional De Técnicos em Radiologia',
  CRQ: 'Conselho Regional De Química',
  CRBIO: 'Conselho Regional De Biologia'
};


const DistrictEnum: { [key: string]: string } = {
  AC: 'Acre',
  AL: 'Alagoas',
  AP: 'Amapá',
  AM: 'Amazonas',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MT: 'Mato Grosso',
  MS: 'Mato Grosso do Sul',
  MG: 'Minas Gerais',
  PA: 'Pará',
  PB: 'Paraíba',
  PR: 'Paraná',
  PE: 'Pernambuco',
  PI: 'Piauí',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RS: 'Rio Grande do Sul',
  RO: 'Rondônia',
  RR: 'Roraima',
  SC: 'Santa Catarina',
  SP: 'São Paulo',
  SE: 'Sergipe',
  TO: 'Tocantins',
}
@Component({
  selector: 'app-council-form',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './dialog-council-form.component.html',
  styleUrl: './dialog-council-form.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogCouncilFormComponent implements OnInit {
  private fb = inject(FormBuilder);
  private councilService = inject(CouncilControllerService);
  public dialogRef = inject(MatDialogRef<DialogCouncilFormComponent>);
  deviceService = inject(DeviceDetectorService);
  data = inject(MAT_DIALOG_DATA);
  councilForm!: FormGroup;
  council!: Council;
  isMobile = this.deviceService.isMobile();

  councilGroupEnum = Object.entries(CouncilGroupEnum).map(([key, value]) => ({
    code: key,
    description: value,
  }));

  districtEnum = Object.entries(DistrictEnum).map(([key, value]) => ({
    code: key,
    description: value,
  }));

  ngOnInit() {
    this.councilForm = this.fb.group({
      id: [null],
      councilGroup: ['', Validators.required],
      councilInscriptionNumber: ['', Validators.required],
      district: ['', Validators.required],
      firstInscriptionUF: [''],
      councilInscriptionDate: ['', Validators.required],
      councilStatus: [''],
      certifiedHubMedical: [''],
      council: this.fb.array([]),
      profileProviderPF: [this.data.profileProviderPF],
    });

    if (this.data.council) {
      this.councilForm.patchValue(this.data.council);
    }
  }

  async saveCouncil() {
    if (this.councilForm.valid) {
      if (this.councilForm.controls['id'].value == null) {
        await this.councilService
          .save13(this.councilForm.value)
          .subscribe((council) => {
            this.dialogRef.close(council);
          });
      } else {
        await this.councilService
          .update16(this.councilForm.value.id, this.councilForm.value)
          .subscribe((council) => {
            this.dialogRef.close(council);
          });
      }
    }
  }
}
